import React from 'react'
import { getGatsbyImageData } from 'gatsby-source-sanity'
import { GatsbyImage } from 'gatsby-plugin-image'
import { injectIntl } from 'gatsby-plugin-intl'
import styled from 'styled-components'
import breakpoints from '../../../util/style/breakpoints'
import { numberWithDots } from '../../../util/js/numberWithDots'

const Hero = styled.div`
  position: relative;
  margin-right: -15px;
  margin-left: -15px;
  ${breakpoints.md`
    margin-left: inherit;
    margin-right: inherit;
  `};
`

const ImgWrapper = styled.div`
  height: 205px;
  position: relative;

  ${breakpoints.md`
    height: 600px;
  `};
`
const ObjectImgDetails = styled.div`
  display: inline-flex;
  align-items: stretch;
  flex-flow: nowrap;
  margin-bottom: 3.5rem;
  margin-left: 1rem;
  background: ${(props) => props.theme.$gray};
  font-size: 1.25rem;
  ${breakpoints.md`
    align-items: center;
    padding: 1.5rem;
    font-size: 2rem;
  `};

  ${breakpoints.lg`
    padding: 2.375rem;
  `};
  p {
    display: inline-block;
    color: ${(props) => props.theme['$gray-lightest']};
    margin: 0;
    padding: 1rem;
    margin-right: 0;
    ${breakpoints.md`
      padding: 0;
      margin-right: 1.5rem;
      font-size: 2rem;
    `};
    span {
      font-weight: 300;
      font-size: 1rem;
      ${breakpoints.md`
      padding: 0;
      font-size: 1.5rem;
    `};
    }
  }
  .availabilty {
    display: flex;
    align-items: center;
    background: ${(props) => props.theme['$brand-primary300']};
    padding: 0.5rem 0.75rem;
    color: ${(props) => props.theme['$gray-dark']};
    margin-bottom: 0;
    font-size: 1rem;
    text-align: center;
    ${breakpoints.md`
      font-size: 1.25rem;
    `};

    .white {
      color: white;
    }
  }

  ${breakpoints.md`
    position: absolute;
    z-index: 10;
    top: 0;
    transform: translate(-50%, -50%);
    left: 50%;
  `};
`

const ObjectDetailImageHeader = ({
  intl,
  rentOrBuyProperty,
  transfer,
  imgHeader,
}) => {
  const sanityConfig = {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID,
    dataset: process.env.GATSBY_SANITY_DATASET,
  }
  const imgHeaderData = getGatsbyImageData(
    imgHeader,
    { width: 1600 },
    sanityConfig
  )
  return (
    <>
      <Hero>
        {transfer && (
          <ObjectImgDetails>
            {transfer.price && (
              <>
                <p>
                  € {numberWithDots(transfer.price)}
                  {rentOrBuyProperty === 'RENT_PROPERTY' && (
                    <span> {intl.formatMessage({ id: 'per_month' })}</span>
                  )}
                  {rentOrBuyProperty === 'BUY_PROPERTY' && (
                    <span> {intl.formatMessage({ id: 'COST_BUYER' })}</span>
                  )}
                </p>
              </>
            )}
            {transfer.availabilty && (
              <div className="availabilty">
                <span
                  className={transfer.availabilty !== 'AVAILABLE' ? 'white' : undefined}
                >
                  {intl.formatMessage({ id: transfer.availabilty })}
                </span>
              </div>
            )}
          </ObjectImgDetails>
        )}

        <ImgWrapper>
          <GatsbyImage
            alt=""
            image={imgHeaderData}
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
            }}
          />
        </ImgWrapper>
      </Hero>
    </>
  )
}

export default injectIntl(ObjectDetailImageHeader)
